import { inject, Injectable } from '@angular/core';
import { AlarisConfigService } from '@campaign-portal/components-library';

@Injectable({
	providedIn: 'root',
})
export class SessionDataService<T> {
	private readonly config = inject(AlarisConfigService);

	STORAGE_KEY = this.config.localStorageKey;

	saveToSession(item: T): void {
		try {
			const serializedValue = JSON.stringify(item);
			sessionStorage.setItem(this.STORAGE_KEY, serializedValue);
		} catch (error) {
			console.error('Serialization error', error);
		}
	}

	loadFromSession(): T | null {
		try {
			const data = sessionStorage.getItem(this.STORAGE_KEY);
			return data ? (JSON.parse(data) as T) : null;
		} catch (error) {
			console.error('Deserialization error', error);
			return null;
		}
	}

	clearSession(): void {
		sessionStorage.removeItem(this.STORAGE_KEY);
	}
}
